export default "__VITE_PUBLIC_ASSET__0e926ff4__"